import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_NEXT_VIDEO,
    FAILURE_VIDEO_CATEGORIES,
    FAILURE_VIDEO_LANGUAGES,
    FAILURE_VIDEO_TOPICS,
    REQUEST_NEXT_VIDEO,
    REQUEST_VIDEO_CATEGORIES,
    REQUEST_VIDEO_LANGUAGES,
    REQUEST_VIDEO_TOPICS,
    SUCCESS_NEXT_VIDEO,
    SUCCESS_VIDEO_CATEGORIES,
    SUCCESS_VIDEO_LANGUAGES,
    SUCCESS_VIDEO_TOPICS,
} from 'src/store/video/actions';

/* Video Topics */
export function videoTopicsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_TOPICS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_TOPICS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_TOPICS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Video Categories by topic */
export function videoCategoriesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_CATEGORIES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_CATEGORIES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_CATEGORIES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Video Languages */
export function videoLanguagesReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_VIDEO_LANGUAGES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_VIDEO_LANGUAGES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_VIDEO_LANGUAGES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Next Video */
export function nextVideoReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_NEXT_VIDEO:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_NEXT_VIDEO: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_NEXT_VIDEO:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
